import React from 'react';
import { Table } from 'UI';
import SectionBasePage from 'components/SectionBasePage';
import { useBreadcrumbNavigation } from 'hooks/breadcrumb';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';
import { ResourceCategoryEnum, ResourceCategoryMapping } from 'constants/resource';

import {
  MainContainer,
  ActionButton,
} from './style';

const ClientInventoryRootPage = (): JSX.Element => {
  const breadcrumbNavigator = useBreadcrumbNavigation();
  const { url } = useRouteMatch();
  const resourceCategories = Object
    .values(ResourceCategoryEnum)
    .map((categoryKey) => {
      const { root } = ROUTES.dashboard.inventory.client.resource;
      const category = ResourceCategoryMapping[categoryKey];
      return {
        key: categoryKey,
        title: category.name,
        route: `${root}/${category.url}`,
      };
    });
  const inventoryCategories = [
    {
      key: 'seed',
      title: 'Sementes',
      route: ROUTES.dashboard.inventory.client.seed.root,
    },
    {
      key: 'tray',
      title: 'Bandejas',
      route: ROUTES.dashboard.inventory.client.tray.root,
    },
    ...resourceCategories,
  ];

  return (
    <SectionBasePage>
      <MainContainer>
        <Table
          dataSource={inventoryCategories}
          pagination={false}
        >
          <Table.Column
            title="Estoques"
            key="categories"
            dataIndex="title"
          />
          <Table.Column
            title=""
            dataIndex="route"
            width="150px"
            render={(route, record: { title: string }) => (
              <ActionButton onClick={() => breadcrumbNavigator.push({
                label: `${record.title}`,
                url: `${url}${route}`,
              })}
              >
                visualizar »
              </ActionButton>
            )}
          />
        </Table>
      </MainContainer>
    </SectionBasePage>
  );
};

export default ClientInventoryRootPage;
